import { useTranslation } from '@portals-platform/i18n';
import type { RefObject } from 'react';
import { useMemo, useRef } from 'react';
import type { Resolver } from 'react-hook-form';
import type { CertificateTemplateResponse } from '../../../data-access/api/responses.js';
import { getResolver } from '../resolver.js';
import type { FormValues } from '../types.js';

export function useResolver(): {
  resolver: Resolver<FormValues>;
  templatesRef: RefObject<CertificateTemplateResponse[]>;
} {
  const { t } = useTranslation();
  const templatesRef = useRef<CertificateTemplateResponse[]>([]);

  const resolver = useMemo(
    () =>
      getResolver({
        templatesRef,
        messages: {
          requiredMessage: t('validation.required'),
          invalidYearMessage: t('validation.invalidYear'),
          invalidAmountMessage: t('validation.invalidAmount'),
        },
      }),
    [t],
  );

  return { resolver, templatesRef };
}
